// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__vyqPd","content":"styles_content__3geP4","checkbox":"styles_checkbox__131Fn","checkboxLabel":"styles_checkboxLabel__1F83w"};